import React, { useEffect, useState } from "react";
import { ModalProps } from "../../interfaces/modal";
import { useSocialStore } from "../../stores/social";
import {
  validateBulletins,
  validateMonth,
  validateSaisie,
} from "../../api/social";
import { showToastError, showToastSuccess } from "../../services/toast";
import { useUserContext } from "../../contexts/userContext";
import {
  ModalButton,
  ModalConfirmText,
  ModalShell,
} from "../ui/modals/ModalShell";

const Validate: React.FC<ModalProps> = ({ closeModal, buttonText }) => {
  const { typeRole } = useUserContext();
  const { tabSocial, setTabSocial, idCustomer, setUpdateSocial, updateSocial } = useSocialStore();
  const [text, setText] = useState<string>("");
  const [warning, setWarning] = useState<string>("");

  useEffect(() => {
    if (tabSocial === "Salariés") {
      setText("la saisie des salariés");
      setWarning(
        "Attention, cette action est irréversible. Vous ne pourrez plus saisir des données pour ce mois ci"
      );
    } else if (tabSocial === "Bulletins" && buttonText === "Accept") {
      setText("l'integralité des bulletins");
      setWarning("Attention, cette action est irréversible.");
    } else if (tabSocial === "Bulletins" && typeRole === "Company" && buttonText === "Month") {
      setText("le mois");
      setWarning(
        "Attention, cette action est irréversible. Ceci passera à la saisie des bulletins pour le mois suivant, et entrainera la clôture du mois en cours."
      );
    }
  }, [tabSocial, typeRole]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (tabSocial === "Salariés") {
      validateSaisie(idCustomer)
        .then(() => {
          showToastSuccess("Validation effectuée.");
          setUpdateSocial(!updateSocial);
          closeModal();
        })
        .catch(() => {
          showToastError("Une erreur est survenue lors de la validation.");
        });
    } else if (tabSocial === "Bulletins" && buttonText === "Accept") {
      validateBulletins(idCustomer)
        .then(() => {
          showToastSuccess("Validation effectuée.");
          setUpdateSocial(!updateSocial);
          closeModal();
        })
        .catch(() => {
          showToastError("Une erreur est survenue lors de la validation.");
        });
    } else if (tabSocial === "Bulletins" && typeRole === "Company" && buttonText === "Month") {
      validateMonth(idCustomer)
        .then((res) => {
          setUpdateSocial(true);
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `archive_social_${idCustomer}`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          closeModal();
          showToastSuccess("Validation effectuée.");
          setTabSocial("Dossier clients social");
        })
        .catch(() => {
          showToastError("Une erreur est survenue lors de la validation.");
        });
    }
  };

  return (
    <ModalShell
      title="Validation"
      size="sm"
      onClose={() => closeModal()}
      footer={
        <>
          <ModalButton variant="secondary" onClick={() => closeModal()}>
            Annuler
          </ModalButton>
          <ModalButton variant="success" type="submit" onClick={handleSubmit}>
            Valider
          </ModalButton>
        </>
      }
    >
      <ModalConfirmText>
        Etes-vous sûr de bien vouloir valider {text} ?
      </ModalConfirmText>
      {warning ? (
        <p className="mt-3 rounded-xl bg-amber-50 px-3 py-2 text-center font-Nunito text-xs text-amber-800 ring-1 ring-amber-100 ring-inset">
          {warning}
        </p>
      ) : null}
    </ModalShell>
  );
};

export default Validate;
